import React, { useContext } from "react";
import { Context } from "../index";
import { observer } from "mobx-react-lite";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./header/Header";
import InfoBoard from "./organization/infoboard/InfoBoard";
import Footer from "./footer/Footer";
import LoginForm from "./loginform/LoginForm";

import "./layout.css";

export default observer(function Layout() {
  const { store } = useContext(Context);
  const location = useLocation();

  return (
    <div className="layout">
      {!store.isAuth && <LoginForm />}
      <Header />

      {store.isAuth &&
        (store.user.role === "оператор организации" ||
          location.pathname.startsWith("/inplants")) && <InfoBoard />}

      <main>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
});
